import React from 'react';

const AssessmentContext = React.createContext();

export default AssessmentContext;
